const items = ["Tornitura", "Fresatura 5 Assi", "Rettifica", "Metrologia", "Stampa 3D", "Industrializzazione", "Prototipazione"];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <section data-testid="marquee" className="border-y border-white/10 bg-zinc-900/40 py-6 overflow-hidden">
      <div className="animate-marquee">
        {row.map((item, i) => (
          <span key={i} className="inline-flex items-center">
            <span className="font-display font-bold uppercase text-2xl md:text-4xl tracking-tight text-zinc-200 px-8">
              {item}
            </span>
            <span className="w-2 h-2 bg-red-600 rotate-45" />
          </span>
        ))}
      </div>
    </section>
  );
};
